import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.8rem",
  padding: "1.5rem 0",
  lineHeight: "2rem",
  fontSize: "1.4rem",

  ".date": {
    color: theme.color.light_gray,
    lineHeight: "1.6rem",
    fontWeight: theme.fontWeight.medium,
  },
}));

const DateBox = styled.div({
  display: "flex",
  alignItems: "flex-start",
  gap: "0.5rem",
});

const Ball = styled.div(({ theme }) => ({
  width: "7px",
  height: "7px",
  borderRadius: "50%",
  backgroundColor: theme.color.mint,
}));

type Props = {
  date: string;
  isRead: boolean;
  title: string;
  newsId: number;
  onClick: () => void;
};
const NewsCard = ({ date, isRead, title, newsId, onClick }: Props) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    onClick();
    navigate(`/news/${newsId}`);
  };

  return (
    <Container onClick={handleClick}>
      <DateBox className="date">
        <span>{date}</span>
        {!isRead && <Ball />}
      </DateBox>
      <p>{title}</p>
    </Container>
  );
};

export default NewsCard;
